export function localText(vm, zh, en) {
  return vm && vm.$i18n && vm.$i18n.locale === 'en' ? en : zh;
}

export function isActiveDispute(row) {
  const st = row && row.disputeStatus ? String(row.disputeStatus) : (row && row.dispute && row.dispute.status ? String(row.dispute.status) : '');
  return !!st && st !== 'DISPUTE_CLOSED';
}

export function caseStatusLabel(vm, row) {
  if (isActiveDispute(row)) return localText(vm, '争议中', 'Disputing');
  const st = row && row.status ? String(row.status) : '';
  const key = `status.ticket.${st}`;
  try {
    if (vm && vm.$i18n && vm.$i18n.te && vm.$i18n.te(key)) return vm.$t(key);
  } catch (e) {}
  return st || '-';
}

export function disputeStatusLabel(vm, row) {
  const status = row && row.disputeStatus ? row.disputeStatus : (row && row.dispute ? row.dispute.status : null);
  const result = row && row.disputeResult ? row.disputeResult : (row && row.dispute ? row.dispute.result : null);
  if (!row || !status) return '-';
  if (status === 'DISPUTE_CLOSED' && result) {
    const resultKey = `dispute.result.${result}`;
    try {
      if (vm && vm.$i18n && vm.$i18n.te && vm.$i18n.te(resultKey)) return vm.$t(resultKey);
    } catch (e) {}
    return result;
  }
  const key = `status.dispute.${status}`;
  try {
    if (vm && vm.$i18n && vm.$i18n.te && vm.$i18n.te(key)) return vm.$t(key);
  } catch (e) {}
  return status;
}

function isSecondarySelfSubmitted(vm, row) {
  const user = vm && vm.$store && vm.$store.state ? vm.$store.state.user : null;
  return !!(
    user &&
    user.role === 'SECONDARY_HANDLER' &&
    row &&
    row.createdBy != null &&
    String(row.createdBy) === String(user.id) &&
    String(row.targetType || 'POOL') === 'POOL'
  );
}

export function flowLabel(vm, row) {
  if (!row) return '-';
  if (isActiveDispute(row)) return localText(vm, '争议处理中', 'Dispute in progress');

  const target = String(row.targetType || 'POOL');
  const status = String(row.status || '');

  if (isSecondarySelfSubmitted(vm, row)) {
    if (status === 'IN_PROGRESS') return localText(vm, '二级处理员提交 -> 处理员处理中', 'Secondary submitted -> Handler in progress');
    if (status === 'WAITING_RESUBMIT') return localText(vm, '处理员退回二级处理员', 'Handler returned to secondary');
    if (status === 'CLOSED') return localText(vm, '二级处理员提交 -> 完结', 'Secondary submitted -> Closed');
    if (status === 'CANCELED') return localText(vm, '二级处理员提交 -> 已取消', 'Secondary submitted -> Canceled');
    return localText(vm, '二级处理员提交 -> 处理员公共池', 'Secondary submitted -> Handler pool');
  }

  if (target === 'SECONDARY_HANDLER') {
    if (status === 'PENDING_SECONDARY') return localText(vm, '指定二级处理员处理中', 'Assigned secondary handler');
    if (status === 'ESCALATED') return localText(vm, '二级处理员 -> 处理员公共池', 'Secondary -> Handler pool');
    if (status === 'IN_PROGRESS') return localText(vm, '二级处理员 -> 处理员处理中', 'Secondary -> Handler in progress');
    if (status === 'ESCALATED_RETURNED') return localText(vm, '处理员退回二级处理员', 'Handler returned to secondary');
    if (status === 'WAITING_RESUBMIT') return localText(vm, '二级处理员退回用户', 'Secondary returned to user');
    if (status === 'CLOSED') {
      return row.escalatedAt
        ? localText(vm, '二级处理员 -> 处理员 -> 完结', 'Secondary -> Handler -> Closed')
        : localText(vm, '二级处理员 -> 完结', 'Secondary -> Closed');
    }
    if (status === 'CANCELED') return localText(vm, '二级处理员链路已取消', 'Secondary flow canceled');
    return localText(vm, '指定二级处理员', 'Specific secondary handler');
  }

  if (status === 'IN_PROGRESS') return localText(vm, '处理员处理中', 'Handler in progress');
  if (status === 'WAITING_RESUBMIT') return localText(vm, '处理员退回用户', 'Handler returned to user');
  if (status === 'CLOSED') return localText(vm, '处理员完结', 'Handler closed');
  if (status === 'CANCELED') return localText(vm, '已取消', 'Canceled');
  return localText(vm, '处理员公共池', 'Handler pool');
}
